import { Navigation } from 'lucide-react'
import type { BlockProps } from '../types.js'
import { NaverMapView } from './NaverMapView.js'
import common from './common.module.css'

interface MapBlockProps extends Pick<BlockProps, 'invitation' | 'mode'> {
  css: Record<string, string>
}

function getMapLinks(venue: { name?: string; lat?: number; lng?: number; address?: string }) {
  const name = venue.name ?? ''
  const addr = venue.address ?? ''
  const lat = venue.lat!
  const lng = venue.lng!
  const encodedName = encodeURIComponent(name || addr)

  return [
    { label: '네이버지도', url: `https://map.naver.com/v5/search/${encodedName}?c=${lng},${lat},15,0,0,0,dh` },
    { label: '카카오지도', url: `https://map.kakao.com/link/to/${encodedName},${lat},${lng}` },
    { label: 'Tmap', url: `tmap://route?goalname=${encodedName}&goalx=${lng}&goaly=${lat}` },
  ]
}

export function MapBlock({ invitation, mode, css }: MapBlockProps) {
  const venue = invitation.wedding?.venue
  const hasCoords = typeof venue?.lat === 'number' && typeof venue?.lng === 'number'
  const hasTransport = !!venue?.transportation
  const hasParking = !!venue?.parking

  if (!hasCoords && !hasTransport && !hasParking) return null

  const mapLinks = hasCoords ? getMapLinks(venue!) : []

  return (
    <div className={common.section}>
      {/* {venue?.address && <p className={css.addressText}>{venue.address}</p>} */}
      {hasCoords && (
        <>
          <NaverMapView
            lat={venue!.lat!}
            lng={venue!.lng!}
            interactive={mode === 'viewer'}
            label={venue?.name}
          />
          <div className={common.mapLinks}>
            {mapLinks.map((link) => (
              <a
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className={common.mapLinkBtn}
              >
                <Navigation size={10} />
                {link.label}
              </a>
            ))}
          </div>
        </>
      )}
      {hasTransport && (
        <>
          <span className={common.listItemTitle}>교통편 안내</span>
          <p className={css.transportText}>{venue!.transportation}</p>
        </>
      )}
      {hasParking && (
        <>
          <span className={common.listItemTitle}>주차 안내</span>
          <p className={css.transportText}>{venue!.parking}</p>
        </>
      )}
    </div>
  )
}
